export default __webpack_public_path__ + "static/media/Hand.b46d0704.svg";